import { render } from "./diceHome.vue?vue&type=template&id=045d0d47&scoped=true"
import script from "./diceHome.vue?vue&type=script&lang=js"
export * from "./diceHome.vue?vue&type=script&lang=js"

import "../assets/css/game_sicb.css?vue&type=style&index=0&id=045d0d47&scoped=true&lang=css"
import "./diceHome.vue?vue&type=style&index=1&id=045d0d47&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045d0d47"]])

export default __exports__